<template>
  <div class="container bottom-fix-padding">
    <v-address v-if="ifAddr" @change="changeAddr" @close="addrClose()"></v-address>
    <div v-show="!ifAddr">
      <div class="navi">
          <span class="icon-arrow-left" @click="goBack()"></span><div class="addr-title">服务地址详情</div><span></span>
      </div>
      <div class="weui-cells__title">个人信息</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text" placeholder="请输入联系人名字" v-model="order.data.address_name"/>
              </div>
          </div>
          <div class="weui-cell weui-cells_form">
              <div class="weui-cell__hd">
                  <label class="weui-label">手机号</label>
              </div>
              <div class="weui-cell__bd">
                  <input class="weui-input" type="tel"  pattern="[0-9]*" placeholder="请输入手机号" v-model="order.data.address_phone" />
              </div>

          </div>
      </div>

      <div class="weui-cells__title">服务地址</div>
      <div class="weui-cells weui-cells_form" v-if="!order.data.address_street">
          <div class="weui-cell weui-cell_access padding-fix" @click="addrSelect()">
              <div class="weui-cell__hd"><label class="weui-label">地址</label></div>
              <div class="weui-cell__bd">
                  <input class="weui-input" type="text"  placeholder="如: 2/9 George Street" />
              </div>
              <div class="weui-cell__ft"></div>
          </div>

      </div>
      <div class="weui-cells" v-if="order.data.address_street">
          <div class="weui-cell" @click="addrSelect()">
              <div class="weui-cell__hd">
                  <label class="weui-label">详细地址</label>
              </div>
              <div class="weui-cell__bd">
                  {{order.data.address_street}} <br> {{ order.data.address_suburb + " "+ order.data.address_state + " " + order.data.address_postcode}}
              </div>
          </div>
      </div>

      <div class="weui-cells__title to-parking" v-show="order.data.address_suburb">停车位</div>
      <div class="weui-cells weui-cells_checkbox" v-show="order.data.address_suburb">
          <label class="weui-cell weui-check__label" for="s11">
              <div class="weui-cell__hd">
                  <input type="radio" class="weui-check" name="checkbox1" id="s11" value="1" v-model="order.data.parking" @click="scrollToParking()">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>我有停车位</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="s12">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox1" class="weui-check" id="s12" value="2" v-model="order.data.parking" @click="scrollToParking()">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>我没停车位，但是我可预约临时停车位</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="s13">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox1" class="weui-check" id="s13" value="3" v-model="order.data.parking" @click="scrollToParking()">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>我无法提供停车位</p>
              </div>
          </label>

          <label class="weui-cell weui-check__label" for="s14" v-if="isEditing">
              <div class="weui-cell__bd">
                  <p class="park-assist" @click="$router.push('/clean-parking');"> <span class="icon-help-circle parking-icon"></span> 教我如何选择这个 </p>
              </div>
          </label>

          <label class="weui-cell weui-check__label" for="s14" v-if="!isEditing">
              <div class="weui-cell__bd">
                  <p class="park-assist" @click="orderUpdateAll('/clean-parking')"> <span class="icon-help-circle parking-icon"></span> 教我如何选择这个 </p>
              </div>
          </label>
      </div>

      <div class="weui-cells__title" v-show="order.data.address_suburb">楼层电梯 (含复式户型内部楼梯)</div>

      <div class="weui-cells weui-cells_checkbox" v-show="order.data.address_suburb">
          <label class="weui-cell weui-check__label" for="k11">
              <div class="weui-cell__hd">
                  <input type="radio" class="weui-check" name="checkbox2" id="k11" value="1" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>住处有电梯，或住Ground层</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k12">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox2" class="weui-check" id="k12" value="2" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>无电梯，需走1层楼梯</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k13">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox2" class="weui-check" id="k13" value="3" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>无电梯，需走2层楼梯</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k14">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox2" class="weui-check" id="k14" value="4" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>无电梯，需走3层楼梯</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k15">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox2" class="weui-check" id="k15" value="5" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>无电梯，需走4层楼梯</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k16">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox2" class="weui-check" id="k16" value="6" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>无电梯，需走5层楼梯</p>
              </div>
          </label>
          <label class="weui-cell weui-check__label" for="k17">
              <div class="weui-cell__hd">
                  <input type="radio" name="checkbox2" class="weui-check" id="k17" value="7" v-model="order.data.floor">
                  <i class="weui-icon-checked"></i>
              </div>
              <div class="weui-cell__bd">
                  <p>无电梯，需走5层以上楼梯</p>
              </div>
          </label>
      </div>


      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
        </div>
      </div>

      <div v-show="isCheckPhone">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">手机号确认</strong></div>
              <div class="weui-dialog__bd">请仔细检查手机号是否正确<div class="check-phone">{{order.data.address_phone}}</div></div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="isCheckPhone = false">返回修改</a>
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="orderUpdateAll('/organization-step4')">确认正确</a>
              </div>
          </div>
      </div>

      <img :src="pixelURL('organization','dizhi')" class="hide">
    </div>
  </div>
</template>

<script>

import anime from 'animejs';

export default {
  name: 'HelloWorld',
  data () {
    return {
      'order':{},
      'address':{},
      'ifAddr':'',
      'isEditing' : localStorage.isEditing,
      'isCheckPhone' : false
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "organization"){
        this.order = localParsed;
        document.querySelector("html").classList.add("grey-background");
        if(this.order.data.address_name && this.order.data.address_phone){
            this.userCatch("1550735960",this.order.data.address_name,this.order.data.address_phone);
        }
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
    if(this.order.data.address_name==""&&localStorage.member_name){
        this.order.data.address_name = localStorage.member_name;
    }
    if(this.order.data.address_phone==""&&localStorage.member_phone){
        this.order.data.address_phone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    addrSelect: function() {
      this.rememberTop = window.scrollY;
      this.ifAddr=true;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    changeAddr: function(emit_street,emit_suburb,emit_state,emit_postcode) {
      this.order.data.address_street = emit_street;
      this.order.data.address_postcode = emit_postcode;
      this.order.data.address_suburb = emit_suburb;
      this.order.data.address_state = emit_state;
      this.sleep(10).then(() => {
          document.documentElement.scrollTop = this.rememberTop;
          document.body.scrollTop = this.rememberTop;
      });
      this.ifAddr=false;

    },
    addrClose: function() {
      this.sleep(10).then(() => {
          document.documentElement.scrollTop = this.rememberTop;
          document.body.scrollTop = this.rememberTop;
      });
      this.ifAddr=false;
    },
    allFilled(){
        if(this.order.data.address_name && this.order.data.address_phone && this.order.data.address_street && this.order.data.address_suburb && this.order.data.address_state && this.order.data.floor && this.order.data.address_name && this.order.data.address_phone && this.order.data.address_postcode && this.order.data.parking){
            return true;
        }
    },
    formatCheck(){
        if (!this.order.data.address_phone) {
            alert('请填写手机号');
        }
        else if (this.order.data.address_phone.length<8 || this.order.data.address_phone.length>11) {
            alert("手机号码长度不正确，请检查是否正确");
        }
        else if(!this.order.data.address_street){
            alert('请填写搬出 Street');
        }
        else if (this.order.data.address_street.length<8) {
            alert('搬出Street长度太短，请检查是否正确');
        }
        else if (this.order.data.address_street.length>40) {
            alert('搬出Street长度太长，请检查是否正确');
        }
        else if (this.order.data.address_postcode.length!=4) {
            alert('请填写4位postcode号码');
        }
        else{
            return true;
        }
    },
    checkSubmit(){
        if(this.formatCheck()){
            if(this.allFilled()){
                if(this.checkLogin()){
                    this.orderUpdateAll('/organization-step4');
                }
                else{
                    this.isCheckPhone = true;
                }
            }
            else{
                alert('请填写完所有地址信息')
            }
        }
    },
    calFloorFee(floor){
      let price = 10;

      let result = floor*price;
      return result;
    },
    scroll(arg) {
        let el = document.querySelector(arg.to),
            offset = parseInt(arg.offset) || 0,
            duration = arg.duration || 1500,
            easing = arg.easing || 'easeInOutQuart',
            callback = arg.callback || null;

        if ( el ) {
            anime({
                targets: ['html', 'body'],
                scrollTop: (el.offsetTop - offset),
                duration: duration,
                easing: easing,
                complete: callback
            })
            .finished.then(() => {
                this.$emit('scroll:finished', true);
            });
        }
    },
    scrollToParking(){
        this.scroll({
            to: '.to-parking'
        });
    },
    goBack(){
      this.goto('/organization-step2')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.navi{
    display: flex;
    justify-content:space-between;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
}

.container{
  background-color: #f8f8f8;
  padding-bottom:60px;
}
.weui-cells__title{
  margin-top:20px;
}


.addr-title{
    font-size:0.6em;
    line-height:2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

.parking-icon{
    color:#fe9567;
    line-height:1.5;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}


.padding-fix{
    padding-right:13px;
}

.placeholder-color{
    color:#777;
}
</style>



// WEBPACK FOOTER //
// src/pages/organization/step3.vue